import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "../components/Projects/ProjectCard";
import Particle from "../components/Particle";
import pg from "../assets/projects/pg.png";
import project from "../assets/projects/project.jpeg";
import lift from "../assets/projects/lift.png";
import krypto from "../assets/projects/krypto.png";
import kickstart from "../assets/projects/kickstart.png";

const Projects = () => {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Recent Top <strong className="yellow">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={lift}
              isBlog={false}
              title="DadJokes"
              description= "IDad Joke Generator This project is a simple web application that generates dad jokes with the click of a button. Leveraging the icanhazdadjoke API, it fetches random dad jokes and displays them on the webpage. The application is built using HTML, CSS, and JavaScript, with the fetch API for making asynchronous requests. It employs modern JavaScript features like async/await for cleaner and more readable code.

              Features:
              
              Fetches random dad jokes from the icanhazdadjoke API.
              Updates the joke display dynamically without refreshing the page.
              Simple and intuitive user interface with a single button to generate jokes.
              Feel free to contribute, suggest improvements, or report issues! 🎉."
              ghLink="https://nutika16.github.io/DadJokes/ "
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={project}
              isBlog={false}
              title="Temperature_Convertor"
              description="Temperature Converter
              A simple temperature converter web application built using HTML, CSS, and JavaScript.
              Description
              This project allows users to convert temperatures between Fahrenheit, Celsius, and Kelvin. Users can input a temperature value in one unit, and the application will automatically update the other units accordingly. Additionally, the application provides emoji feedback based on the Celsius temperature entered.
              Features
              Conversion between Fahrenheit, Celsius, and Kelvin.
              
              Real-time updates as the user inputs temperature values.
              
              Emoji feedback based on the entered Celsius temperature.
              
              Preview
              How to Use
              Enter a temperature value in any of the input fields (Fahrenheit, Celsius, or Kelvin).
              
              The other input fields will automatically update with the corresponding temperature values.
              
              The emoji feedback will provide visual cues based on the entered Celsius temperature.
              
              Installation
              No installation required. Simply open the index.html file in a web browser to use the application.
              Credits
              Bootstrap: Used for styling the application. icanhazdadjoke API: Used for displaying temperature-related emoji feedback.
              Author: Nutika."
              ghLink="https://nutika16.github.io/Temperature_Convertor/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={kickstart}
              isBlog={false}
              title="Instagram_Clone"
              description="This project is a simple clone of the Instagram user interface (UI) built with HTML and CSS. It focuses on replicating the layout and visual elements of the Instagram app, offering a static representation of the platform's design.

              Features:
              1. Header with logo, search bar, and profile section 2. Navigation bar with icons for home, explore, activity, and profile 3. Feed area with placeholder images for posts 4. User profile section with profile picture and follower/following counts
              Getting Started:
              Download the Files:
              Clone or download the repository containing the HTML and CSS files. Open in Browser: Open the index.html file in your web browser.
              Customization: This is a basic foundation. You can customize the design further by:
              
              Adding your own images and text for posts and profiles. Implementing more complex layouts using CSS grids or flexbox. Adding basic interactivity with JavaScript (optional). License:
              
              This project is provided for educational purposes only. You can use and modify it freely for personal learning.
              
              Further Resources:
              Learn more about HTML: https://www.w3schools.com/html/
              
              Learn more about CSS: https://www.w3schools.com/css/
              
              Explore creating interactive web applications with JavaScript: https://developer.mozilla.org/en-US/docs/Web/JavaScript Note:
              
              This clone does not have any functionalities related to user accounts, login, posting, or database interaction. It focuses solely on replicating the UI design."
              ghLink="https://nutika16.github.io/Instagram_replica/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={pg}
              isBlog={false}
              title="Invoice Generator"
              description="This application features a RESTful API server built with Nodejs and Expressjs. The data is retrieved from the API server and displayed on a user-friendly interface designed using React, Redux, and styled-components for a seamless experience."
              ghLink="https://66234c00427b5f8d9d30f402--gentle-kashata-59dcea.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={krypto}
              isBlog={false}
              title="Project Windows 11"
              description="Project Windows 11 is a react  project that utilizes an Ethereum smart contract created using Solidity. It allows users to interact with me and send mesages through whatsapp."
              ghLink="https://6640e52cbad0a3e62e052a9a--cozy-chaja-b89979.netlify.app/"
              demoLink="https://6640e52cbad0a3e62e052a9a--cozy-chaja-b89979.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={kickstart}
              isBlog={false}
              title="Sanjays apna hospital"
              description="Sanjay's Apna Hospital project that utilizes an Ethereum smart contract created using Solidity. "
              ghLink="https://www.sanjaysapnahospital.info/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  )
}

export default Projects